<ag-shr-modal-window
  #mediaUploaderModalRef
  [width]="width"
  [height]="height"
  [title]="'Upload Media'"
  [useScrollView]="false"
  [inProgress]="inProgress$ | async"
  [saveButtonDisabled]="(isFileSelected$ | async) === false"
  [onCloseModal]="onCloseModal"
  (onSaveClick)="saveImage()"
  [customClass]="'media-uploader__popup'"
>
  @if (mediaUploaderModalRef?.popupComponent?.visible) {
    <div class="media-uploader__progress" *ngIf="inProgress$ | async">
      <div class="media-uploader__progress-label">
        Uploading {{ ((uploadProgress$ | async) ?? 0) * 100 | number: "1.0-0" }}%
      </div>
      <div class="media-uploader__progress-bar">
        <div class="media-uploader__progress-bar-fill" [style.width.%]="((uploadProgress$ | async) ?? 0) * 100"></div>
      </div>
    </div>
    <ag-shr-media-sources
      #mediaSourcesRef
      [accept]="accept"
      [placeholder]="placeholder"
      [mediaPathPrefix]="mediaPathPrefix"
      [mediaSources]="mediaSources"
      [mediaItems]="mediaItems"
      [useCustomMediaGallery]="useCustomMediaGallery"
      [maxFileSizeMb]="maxFileSizeMb"
      [applyImageDownscale]="applyImageDownscale"
    >
      <ng-content custom-media-gallery select="[custom-media-gallery]"></ng-content>
      <ng-content from-disk-tab-extra-content select="[from-disk-tab-extra-content]"></ng-content>
    </ag-shr-media-sources>
  }
</ag-shr-modal-window>
